import React from "react";
import { useNavigate } from "react-router-dom";

const COMPANY = "Quattro Games";
const CONTACT_EMAIL = "support@quattro.app";
const EFFECTIVE_DATE = "April 29, 2026";
const APP_NAME = "Quattro";

export default function Terms() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen w-full px-4 md:px-8 py-8" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <button className="btn-ghost" onClick={() => window.history.length > 1 ? nav(-1) : nav("/")} data-testid="terms-back-btn">Back</button>
          <h1 className="font-display font-black text-2xl md:text-3xl">Terms of Service</h1>
        </div>

        <div className="text-white/55 text-xs mb-6">Effective: <b>{EFFECTIVE_DATE}</b></div>

        <article className="prose prose-invert space-y-4 text-sm text-white/80">
          <p>
            By installing or using {APP_NAME} ("the App"), you agree to these
            Terms. If you don't agree, please uninstall the App.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">1. Eligibility</h2>
          <p>
            You must be at least 13 years old to use {APP_NAME}. If you are
            between 13 and the age of majority in your jurisdiction, you must
            have a parent or guardian's permission.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">2. Virtual currency</h2>
          <p>
            <b>Chips</b> and <b>Gems</b> are virtual items with no monetary
            value. You cannot withdraw them, exchange them for real currency,
            or transfer them between accounts. We may add, remove, or change
            virtual items at any time. Purchased Gems are non-refundable except
            where required by applicable law (e.g. the Google Play Store's own
            48-hour refund window, which applies in addition to these Terms).
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">3. Fair play</h2>
          <p>You agree NOT to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Use bots, scripts, modified clients, or any automation to play.</li>
            <li>Reverse-engineer or tamper with the App or our servers.</li>
            <li>Attempt to manipulate match outcomes or chip balances.</li>
            <li>Harass, threaten, or send unlawful content via in-game chat.</li>
            <li>Create accounts on behalf of someone else without permission.</li>
          </ul>
          <p>
            We may suspend or terminate accounts that violate these rules and
            confiscate any chips/gems balance accrued via prohibited means.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">4. User content (chat)</h2>
          <p>
            You own what you say in in-game chat, but you grant us a worldwide,
            non-exclusive license to relay it to other players in the same room
            for the duration of that session. We do not store chat messages. We
            may filter or block messages that contain illegal content, spam,
            or hate speech.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">5. Service availability</h2>
          <p>
            We provide the App "as is" without warranty. We may take the
            service offline for maintenance, and we may modify or discontinue
            features at any time. We aim to give 14 days' notice for major
            removals via in-app banner.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">6. Liability</h2>
          <p>
            To the maximum extent permitted by law, our total liability for any
            claim arising from your use of {APP_NAME} is limited to the amount
            you've paid us in the 12 months preceding the claim, or USD 100,
            whichever is greater. Nothing in these Terms limits liability for
            death, personal injury, or fraud.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">7. Termination</h2>
          <p>
            You can stop using the App and delete your data at any time
            (see <a href="/privacy" className="underline" style={{ color: "#FFD700" }}>Privacy Policy §4</a>).
            We may terminate accounts that violate these Terms.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">8. Governing law</h2>
          <p>
            These Terms are governed by the laws of the jurisdiction where
            {" "}{COMPANY} is registered, without regard to conflict-of-law
            principles. Disputes go to the courts of that jurisdiction.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">9. Changes</h2>
          <p>
            We may update these Terms. Material changes will be notified
            in-app at least 14 days before they take effect.
          </p>

          <h2 className="font-display font-bold text-lg mt-6 mb-2 text-white">10. Contact</h2>
          <p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="underline" style={{ color: "#FFD700" }}>{CONTACT_EMAIL}</a>
          </p>
        </article>
      </div>
    </div>
  );
}
